import { ref as C, reactive as m, computed as b, onMounted as P, onBeforeUnmount as T, createBlock as w, openBlock as y, unref as B, normalizeStyle as $, normalizeClass as M, withCtx as k, resolveDynamicComponent as A, mergeProps as F, toHandlers as L } from "vue";
import { u } from "../index-CwUO-sb6.js";
import { m as S } from "../maxBy-aIdzrXGZ.js";
import { animate as W, focusFirstFocusable as H } from "../lib/utils.js";
import U from "./TrapFocus.js";
const z = {
  topLeft: {
    absOffset: [0, -10],
    refOffset: [0, 0],
    popOffset: [0, -1]
  },
  top: {
    absOffset: [0, -10],
    refOffset: [0.5, 0],
    popOffset: [-0.5, -1]
  },
  topRight: {
    absOffset: [0, -10],
    refOffset: [1, 0],
    popOffset: [-1, -1]
  },
  bottomLeft: {
    absOffset: [0, 10],
    refOffset: [0, 1],
    popOffset: [0, 0]
  },
  bottom: {
    absOffset: [0, 10],
    refOffset: [0.5, 1],
    popOffset: [-0.5, 0]
  },
  bottomRight: {
    absOffset: [0, 10],
    refOffset: [1, 1],
    popOffset: [-1, 0]
  },
  rightTop: {
    absOffset: [10, 0],
    refOffset: [1, 0],
    popOffset: [-0, 0]
  },
  right: {
    absOffset: [10, 0],
    refOffset: [1, 0.5],
    popOffset: [0, -0.5]
  },
  rightBottom: {
    absOffset: [10, 0],
    refOffset: [1, 1],
    popOffset: [0, -1]
  },
  leftTop: {
    absOffset: [-10, 0],
    refOffset: [0, 0],
    popOffset: [-1, 0]
  },
  left: {
    absOffset: [-10, 0],
    refOffset: [0, 0.5],
    popOffset: [-1, -0.5]
  },
  leftBottom: {
    absOffset: [-10, 0],
    refOffset: [0, 1],
    popOffset: [-1, -1]
  }
};
function D(t, a, e) {
  const r = Math.min(
    t.top + a.height,
    e.height
  ), f = Math.min(t.left + a.width, e.width), o = r - Math.max(t.top, 0), n = f - Math.max(t.left, 0), i = o * n, l = a.width * a.height;
  return l !== 0 ? i / l : 0;
}
function j(t, a, e, r, f = z) {
  const i = (t.position ? Array.isArray(t.position) ? t.position : [t.position] : ["bottom", "top", "right", "left"]).map((p) => ({
    absOffset: t.absOffset ?? f[p].absOffset,
    refOffset: t.refOffset ?? f[p].refOffset,
    popOffset: t.popOffset ?? f[p].popOffset
  })).map(({ absOffset: p, refOffset: h, popOffset: d }) => {
    const { xClamp: s, yClamp: c, xPadding: v, yPadding: E } = t, { left: O, top: g } = q(
      {
        absOffset: p,
        refOffset: h,
        popOffset: d,
        xClamp: s,
        yClamp: c,
        xPadding: v,
        yPadding: E
      },
      a,
      e,
      r
    ), x = D({ left: O, top: g }, e, r);
    return { left: O, top: g, fitness: x };
  });
  let l = i.find((p) => p.fitness === 1);
  return l || (l = S(i, (p) => p.fitness)), l;
}
function q(t, a, e, r) {
  let { left: f, top: o } = a;
  if (t.refOffset && (f += t.refOffset[0] * a.width, o += t.refOffset[1] * a.height), t.popOffset && (f += t.popOffset[0] * e.width, o += t.popOffset[1] * e.height), t.absOffset && (f += t.absOffset[0], o += t.absOffset[1]), t.yClamp) {
    const n = o + e.height, i = t.yPadding ?? 0;
    n + i > r.height && (o -= n + i - r.height), o < i && (o += i - o);
  }
  if (t.xClamp) {
    const n = f + e.width, i = t.xPadding ?? 0;
    n + i > r.width && (f -= n + i - r.width), f < i && (f += i - f);
  }
  return f = Math.round(f), o = Math.round(o), { left: f, top: o };
}
const N = {
  __name: "LightPopUp",
  props: {
    popup: {
      type: Object,
      required: !0
    },
    reactToEvents: Boolean
  },
  emits: ["ref-disappeared"],
  setup(t, { emit: a }) {
    const e = t, r = a, f = C(), o = m({
      width: 0,
      height: 0
    }), n = m({
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }), i = m({
      width: 0,
      height: 0
    }), l = b(() => {
      const { left: s, top: c } = j(
        e.popup,
        n,
        i,
        o
      );
      return e.popup.parentStyle({
        transform: `translate(${s}px, ${c}px)`
      });
    }), p = b(() => e.popup.parentClass("fixed top-0 left-0"));
    let h = () => {
    };
    P(() => {
      h = W(d, 1 / 0), e.popup.focus && e.reactToEvents && (f.value.$el.contains(document.activeElement) || H(f.value.$el));
    }), T(() => h());
    function d() {
      if (o.width = document.documentElement.clientWidth ?? 0, o.height = document.documentElement.clientHeight ?? 0, e.popup.ref)
        if (document.body.contains(e.popup.ref)) {
          const s = e.popup.ref.getBoundingClientRect();
          n.top = s.top, n.left = s.left, n.width = s.width, n.height = s.height;
        } else
          r("ref-disappeared");
      if (f.value) {
        const s = f.value.$el.getBoundingClientRect();
        i.width = s.width, i.height = s.height;
      }
    }
    return u(window, "mousedown", (s) => {
      e.reactToEvents && (f.value.$el.contains(s.target) || e.popup.onClickOutside(s));
    }), u(window, "touchstart", (s) => {
      if (!e.reactToEvents || s.touches.length !== 1) return;
      const c = s.targetTouches.item(0);
      f.value.$el.contains(c.target) || e.popup.onClickOutside(s);
    }), u(window, "wheel", (s) => {
      e.reactToEvents && (f.value.$el.contains(s.target) || e.popup.onWheelOutside(s));
    }), u(window, "keyup", (s) => {
      e.reactToEvents && s.key === "Escape" && e.popup.onEscape(s);
    }), (s, c) => (y(), w(B(U), {
      class: M(p.value),
      style: $(l.value),
      enabled: t.popup.focus && t.reactToEvents
    }, {
      default: k(() => [
        (y(), w(A(t.popup.component), F({
          ref_key: "root",
          ref: f
        }, t.popup.props, L(t.popup.on ?? {})), null, 16))
      ]),
      _: 1
    }, 8, ["class", "style", "enabled"]));
  }
};
export {
  D as calcPopFitness,
  j as calcPopPosition,
  q as calcPopPositionWithConstraints,
  N as default
};
